import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { NumericValueComparator } from '@scale/shared-types';

interface NumericComparatorBuilderProps {
  name: string;
  existingValue?: NumericValueComparator;
  updateProperty: (arg: NumericValueComparator) => void;
  required?: boolean;
}

interface ComparatorOption {
  id: NumericValueComparator;
  name: string;
}

const comparatorOptions: Array<ComparatorOption> = Object.values(NumericValueComparator).map(
  comparator => {
    return { id: comparator, name: comparator };
  },
);

const NumericComparatorBuilder: React.FC<NumericComparatorBuilderProps> = ({
  name,
  existingValue,
  updateProperty,
  required,
}) => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center">
        {name && <div className="my-1 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      </div>
      <SelectMenu
        className="min-w-[135px]"
        options={comparatorOptions}
        selectedOptionId={existingValue || NumericValueComparator.Equals}
        setSelected={value => {
          updateProperty(value as NumericValueComparator);
        }}
        required={required}
      />
    </div>
  );
};

export default NumericComparatorBuilder;
